import React, { createContext, useContext } from 'react';
import { useDisclosure } from '@mantine/hooks';
import { useNavigate } from 'react-router';
import { useFlags } from 'src/feature-flags/FlagsHook';
import { useCurrentClientIfAvailable } from 'src/clients/context/CurrentClientProvider';
import DataExportFlow from './DataExportFlow';

type DataExportContextType = {
  opened: boolean;
  open: () => void;
  close: () => void;
};

const DataExportContext = createContext<DataExportContextType>({} as DataExportContextType);

export function useDataExport() {
  const context = useContext(DataExportContext);
  if (context === undefined) {
    throw new Error('useDataExport must be used within a DataExportProvider');
  }
  return context;
}

export default function DataExportProvider({ children }: { children: React.ReactNode }) {
  const [opened, { open: disclosureOpen, close }] = useDisclosure(false);
  const { flagEnabledNewLayout } = useFlags();
  const { client } = useCurrentClientIfAvailable();
  const navigate = useNavigate();

  const value = {
    opened,
    open: () => {
      if (flagEnabledNewLayout) {
        navigate(`/client/${client?.id}/data-export`, {
          state: { fromPath: location.pathname },
        });
        return;
      }
      disclosureOpen();
    },
    close,
  };

  return (
    <DataExportContext value={value}>
      {children}
      <DataExportFlow opened={opened} close={close} />
    </DataExportContext>
  );
}
